import React from 'react';
import {
  Container, Typography, Box, Card, CardContent, Tabs, Tab, Grid, TextField,
  Button, FormControl, InputLabel, Select, MenuItem, FormHelperText,
  Switch, FormControlLabel, Avatar, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Alert, CircularProgress, Snackbar,
  Dialog, DialogTitle, DialogContent, DialogActions, Paper, Chip, IconButton,
  Link, CardActions, Divider, Collapse, Autocomplete
} from '@mui/material';
import {
  Business as BusinessIcon, Add as AddIcon, Edit as EditIcon,
  Delete as DeleteIcon, Save as SaveIcon, LocalOffer as LocalOfferIcon,
  ShoppingCart as ShoppingCartIcon, Settings as SettingsIcon,
  FileDownload as ExportIcon, Link as LinkIcon, Phone as PhoneIcon,
  Tablet as TabletIcon, Computer as ComputerIcon, Article as ArticleIcon,
  Schedule as ScheduleIcon, Close as CloseIcon, Category as CategoryIcon,
  ViewModule as TemplateIcon, TrendingUp as UsageIcon,
  Visibility as PreviewIcon, Create as CreateIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import { Link as RouterLink } from 'react-router-dom';
import OfferPageBuilderSimple from '../../../components/OfferPageBuilderSimple';
import { useBrandsContext } from '../../BrandsContext';

const OfferElementSetupTab = () => {
  const {
    user, navigate,
    activeTab, setActiveTab,
    brandForm, setBrandForm,
    existingBrands, setExistingBrands,
    loading, setLoading,
    error, setError,
    success, setSuccess,
    editingBrand, setEditingBrand,
    editDialogOpen, setEditDialogOpen,
    deleteDialogOpen, setDeleteDialogOpen,
    brandToDelete, setBrandToDelete,
    offerLoading, setOfferLoading,
    offerError, setOfferError,
    categories, setCategories,
    selectedCategory, setSelectedCategory,
    offerForm, setOfferForm,
    editingOffer, setEditingOffer,
    editOfferDialogOpen, setEditOfferDialogOpen,
    deleteOfferDialogOpen, setDeleteOfferDialogOpen,
    offerToDelete, setOfferToDelete,
    availableOffers, setAvailableOffers,
    availableOffersLoading, setAvailableOffersLoading,
    expandedBrands, setExpandedBrands,
    brandOffers, setBrandOffers,
    sharedElements, setSharedElements,
    sharedSelectedElement, setSharedSelectedElement,
    sharedSelectedElementContext, setSharedSelectedElementContext,
    sharedSelectedCategory, setSharedSelectedCategory,
    sharedSelectedSubtype, setSharedSelectedSubtype,
    sharedSelectedBrand, setSharedSelectedBrand,
    sharedSelectedOffer, setSharedSelectedOffer,
    sharedPages, setSharedPages,
    sharedSelectedTemplateId, setSharedSelectedTemplateId,
    fetchBrands, fetchCategories, fetchAvailableOffers,
    handleToggleBrandOffers, handleTabChange, handleOfferFormChange,
    handleCreateOffer, handleEditOffer, handleDeleteOfferClick,
    handleDeleteOfferConfirm, handleDeleteOfferCancel,
    handleEditOfferCancel, handleEditBrand, handleUpdateBrand,
    handleDeleteClick, handleDeleteConfirm, handleDeleteCancel,
    handleCreateBrand,
    isValidUrl,
  } = useBrandsContext();

  return (
    <Box>
      {/* Type and Subtype Selection - Top (Full Width) */}
      <Paper elevation={1} sx={{ p: 1.5, mb: 2 }}>
        <OfferPageBuilderSimple
          templatesOnly={false}
          customElementsOnly={true}
          hideLoadTemplate={true}
          templateSelectionOnly={true}
          typeAndSubtypeOnly={true}
          isBrandsPage={true}
          sharedElements={sharedElements}
          setSharedElements={setSharedElements}
          sharedSelectedElement={sharedSelectedElement}
          setSharedSelectedElement={setSharedSelectedElement}
          sharedSelectedElementContext={sharedSelectedElementContext}
          setSharedSelectedElementContext={setSharedSelectedElementContext}
          sharedSelectedCategory={sharedSelectedCategory}
          setSharedSelectedCategory={setSharedSelectedCategory}
          sharedSelectedSubtype={sharedSelectedSubtype}
          setSharedSelectedSubtype={setSharedSelectedSubtype}
          sharedSelectedBrand={sharedSelectedBrand}
          setSharedSelectedBrand={setSharedSelectedBrand}
          sharedSelectedOffer={sharedSelectedOffer}
          setSharedSelectedOffer={setSharedSelectedOffer}
          sharedPages={sharedPages}
          setSharedPages={setSharedPages}
          sharedSelectedTemplateId={sharedSelectedTemplateId}
          setSharedSelectedTemplateId={setSharedSelectedTemplateId}
        />
      </Paper>
    
      {/* Editor Panel Section - Full Width */}
      <Box sx={{
        minHeight: '400px',
        height: 'calc(100vh - 40px)', // Maximize height in editor mode
        backgroundColor: 'white'
      }}>
        <OfferPageBuilderSimple
          templatesOnly={true}
          customElementsOnly={false}
          hideCustomElements={false}
          hideLoadTemplate={true}
          isBrandsPage={true}
          sharedElements={sharedElements}
          setSharedElements={setSharedElements}
          sharedSelectedElement={sharedSelectedElement}
          setSharedSelectedElement={setSharedSelectedElement}
          sharedSelectedElementContext={sharedSelectedElementContext}
          setSharedSelectedElementContext={setSharedSelectedElementContext}
          sharedSelectedBrand={sharedSelectedBrand}
          setSharedSelectedBrand={setSharedSelectedBrand}
          sharedSelectedOffer={sharedSelectedOffer}
          setSharedSelectedOffer={setSharedSelectedOffer}
          sharedPages={sharedPages}
          setSharedPages={setSharedPages}
          sharedSelectedTemplateId={sharedSelectedTemplateId}
          setSharedSelectedTemplateId={setSharedSelectedTemplateId}
        />
      </Box>
    </Box>
  );
};

export default OfferElementSetupTab;
